// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.cm-s-neo .CodeMirror-linenumber {\n    color: #999;\n}\n.CodeMirror-foldmarker-1 {\n    font-stretch: ultra-condensed;\n    color: white;\n    font-family: arial;\n    background: #8ea0ff;\n    border-radius: 3px;\n    cursor: pointer !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
